// api.js
const BASE_URL = 'https://v3.dhundhoo.com';
export const journey = `${BASE_URL}/reports/journeysReport`;
export const vehicleReport = `${BASE_URL}/reports/vehicleReport`;
export const geoFence = `${BASE_URL}/reports/geofenceReport`;
export const ignition = `${BASE_URL}/reports/ignitionReport`;
export const vehiclePerformance = `${BASE_URL}/reports/vehiclePerformanceReport`;
export const vehicleEdit = `${BASE_URL}/thing/edit`;
export const thingDetails = `${BASE_URL}/things/my`;
export  const GOOGLE_MAPS_API_KEY = "AIzaSyDv1tiSz3aXov0aqMcKu-OflzIIr9XK3mk";
export  const addGeofence = `${BASE_URL}/thing/addGeoFence`;
export  const getGeofence = `${BASE_URL}/thing/getGeoFence`;
export  const removeGeofence = `${BASE_URL}/thing/removeGeoFence`;
export const getGroupVehicleDetails = `${BASE_URL}/group/getGroupVehicleDetails`;
export const editGroupVehiclesDetails = `${BASE_URL}/group/editGroupVehiclesDetails`;
export const deleteGroups = `${BASE_URL}/group/deleteGroups`;
export const getRoleDetails = `${BASE_URL}/ev/getRoleDetails`;
export const createUser = `${BASE_URL}/ev/createUser`;
export const assignGroupToUser = `${BASE_URL}/ev/assignGroupToUser`;
export const deleteSubUser = `${BASE_URL}/ev/deleteSubUser`;
export const routeReplayReport = `${BASE_URL}/reports/routeReplayReport`;
export const haltReport = `${BASE_URL}/reports/haltReport`;
export const AccessReport = `${BASE_URL}/reports/reports/access`;
export const getFleetAnalyticsDetails = `${BASE_URL}/getFleetAnalyticsDetails`;
export const alertCount = `${BASE_URL}/alerts/alertCount`;
export const setAlertConfiguration = `${BASE_URL}/alerts/setAlertConfiguration`;
export const deleteAlertConfiguration = `${BASE_URL}/alerts/deleteAlertConfiguration`;
export const editAlertConfiguration = `${BASE_URL}/alerts/editAlertConfiguration`;
export const getAlertDetails = `${BASE_URL}/alerts/getAlertDetails`;
export const jobReport = `${BASE_URL}/jobwork/report`;
export const jobWorkTypesList = `${BASE_URL}/jobwork/jobWorkTypes`;
export const jobWork = `${BASE_URL}/jobwork`;
export const jobWorkanalysis = `${BASE_URL}/jobwork/analysis`;
export const maintenanceCost = `${BASE_URL}/jobwork/maintenanceCost?type=daszsa`;
export const jobDistribution = `${BASE_URL}/jobwork/jobDistribution`; 
export const vehicleTotalCost = `${BASE_URL}/jobwork/vehicleTotalCost`;